import { AmplifyErrorObject } from "@futrli/shared-services";
import { AuthError } from "./types";

/**
 * Gets the message error or an error and converts it to an auth store error;
 * @param {error: AmplifyErrorObject | string} error
 * @return {Error}
 */
export const stringToErrorStore = (error: AmplifyErrorObject | string): AuthError => {
  let errorToStore = error;

  if (typeof errorToStore === 'string') {
    errorToStore = new Error(errorToStore);
  }

  return {
    name: errorToStore.name,
    message: errorToStore.message,
    code: errorToStore.code
  };
};
